import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const LoadingArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  color: var(--text-secondary);
  svg {
    animation: ${rotate} 1s linear infinite;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;

  .title {
    h1 {
      font-size: 1.75rem;
      color: var(--text-main);
      font-weight: 800;
      margin: 0;
    }
    p {
      color: var(--text-secondary);
      font-size: 0.95rem;
      margin: 4px 0 0 0;
    }
  }

  .refresh-btn {
    all: unset;
    cursor: pointer;
    background: var(--surface);
    padding: 10px;
    border-radius: 12px;
    border: 1px solid var(--border);
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: var(--shadow-sm);

    &:hover {
      background: var(--background);
      color: var(--primary);
      border-color: var(--primary);
      transform: rotate(180deg);
    }
  }
`;

export const FilterBar = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 2rem;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  button {
    all: unset;
    cursor: pointer;
    padding: 10px 20px;
    background: var(--surface);
    border-radius: 12px;
    border: 1px solid var(--border);
    color: var(--text-secondary);
    font-weight: 600;
    font-size: 0.875rem;
    white-space: nowrap;
    transition: all 0.2s;

    &:hover {
      border-color: var(--text-secondary);
    }

    &.active {
      background: var(--primary); /* Ajustado para sua cor principal */
      color: #fff;
      border-color: var(--primary);
      box-shadow: var(--shadow-md);
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
`;

export const ProductCard = styled.div`
  background: var(--surface);
  padding: 24px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  border: 1px solid ${props => props.available ? 'var(--border)' : '#fee2e2'};
  opacity: ${props => props.available ? '1' : '0.75'};
  filter: ${props => props.available ? 'none' : 'grayscale(0.4)'};
  box-shadow: var(--shadow-sm);

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-md);
    border-color: var(--primary);
  }

  .main-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .cat {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
      color: var(--primary);
      background: rgba(16, 185, 129, 0.1);
      padding: 2px 8px;
      border-radius: 6px;
      width: fit-content;
    }

    h3 {
      margin: 4px 0;
      font-size: 18px;
      color: var(--text-main);
      font-weight: 700;
    }

    .price {
      font-weight: 800;
      color: var(--text-main);
      font-size: 16px;
      opacity: 0.9;
    }
  }

  @media (max-width: 480px) {
    padding: 16px;
    h3 { font-size: 16px; }
  }
`;

export const SwitchArea = styled.div`
  .status-toggle {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px 6px 6px;
    border-radius: 99px;
    border: none;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 600;
    font-size: 12px;
    min-width: 90px;
    position: relative;

    .knob {
      width: 24px;
      height: 24px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      color: inherit;
    }

    &.active {
      background: #ecfdf5;
      color: #059669;
      
      .knob {
        transform: translateX(0);
      }
    }

    &.inactive {
      background: #f3f4f6;
      color: #6b7280;
      flex-direction: row-reverse; /* Inverte o ícone de lado */
      padding: 6px 6px 6px 14px;

      .knob {
        transform: translateX(0);
      }
    }

    &:hover {
      filter: brightness(0.95);
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;
